import { Component } from '@angular/core';
import { AlertController, IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';

import { Storage } from '@ionic/storage';
import { AuthProvider } from '../../providers/auth/auth';
import { AngularFireAuth } from 'angularfire2/auth';
import { User } from '../../models/user';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})

export class LoginPage {

  user = {} as User;
  // email: any;
  // password: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private toast: ToastController,
    public alertCtrl: AlertController,
    private  authProvider: AuthProvider,
    private angularFireAuth: AngularFireAuth,
    private storage: Storage) {

  }

  ionViewDidLoad() {
    // this.storage.get('user').then((val) => {
    //   console.log('Current user', val);
    // });
  }

  // onLogin() {
  //   //AR: use local storage for user, hard code value for now
  //   this.storage.set('user', {id:this.email});

  //   this.navCtrl.setRoot('HomePage');
  // }

  async login(user: User) {
    try {
      const result = await this.angularFireAuth.auth.signInWithEmailAndPassword(user.email, user.password);
      if (result) {
        this.storage.set('user', { id: user.email });
        this.navCtrl.setRoot('HomePage');
      }
    }
    catch (e) {
      this.toast.create({
        message: 'Please check your email or password and try again', duration: 3000
      }).present();
    }
  }

  forgotPassword() {

    let prompt = this.alertCtrl.create({
      title: 'Password Reset',
      message: "A new password will be sent to your email",
      inputs: [
        {
          name: 'recoveryEmail',
          placeholder: 'you@example.com'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Send',
          handler: data => {
            this.authProvider.forgotPassword(data.recoveryEmail)
              .then(() => {

                this.toast.create({
                  message: 'Email sent! Please check your inbox.', duration: 3000
                }).present();

              }, error => {
                let alert = this.alertCtrl.create({
                  title: 'Error: Password Reset',
                  subTitle: error.message,
                  buttons: ['OK']
                });
                alert.present();
              });
          }
        }
      ]
    });
    prompt.present();
  }

  goToSignup() {
    this.navCtrl.push('SignupPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts